export const WHATSAPP_NUMBER = "5541997204491";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Olá, Ana! Vim pelo site e gostaria de saber mais sobre a terapia on-line."
)}`;
export const INSTAGRAM_URL = "https://instagram.com/psi.anafalaschi";
export const CRP = "CRP 08/31011";

export const NAV = [
  { id: "inicio", label: "Início" },
  { id: "sobre", label: "Sobre" },
  { id: "como-funciona", label: "Como funciona" },
  { id: "areas", label: "Áreas" },
  { id: "faq", label: "Dúvidas" },
  { id: "contato", label: "Contato" },
];

export const MARQUEE = [
  "A adolescência é o presente em transformação",
  "Cada pessoa carrega uma história que merece ser ouvida",
  "Terapia Cognitivo-Comportamental",
  "Atendimento on-line",
  "Pais & adolescentes em diálogo",
];

export const STEPS = [
  { n: "01", title: "Primeiro contato", text: "Você me chama no WhatsApp. Conversamos sobre horários, valores e tiramos as primeiras dúvidas, com toda a discrição." },
  { n: "02", title: "Sessão de acolhimento", text: "No primeiro encontro on-line, entendemos juntos o que trouxe você até aqui e o que gostaria de transformar." },
  { n: "03", title: "Plano terapêutico", text: "Com base na TCC, definimos objetivos claros e caminhos práticos para lidar com pensamentos, emoções e comportamentos." },
  { n: "04", title: "Encontros de onde você estiver", text: "As sessões acontecem por videochamada. Basta um lugar reservado, internet e fones de ouvido." },
];

export const AREAS = [
  { key: "adolescentes", tag: "Adolescentes", title: "Um espaço para ser ouvido sem julgamentos", text: "Ansiedade, autoestima, escola, amizades, identidade e as muitas emoções de uma fase que é presente — e não só passagem.", tone: "rose", span: "md:col-span-7" },
  { key: "pais", tag: "Pais & adolescentes", title: "Pontes para uma conversa possível", text: "Como facilitadora da comunicação entre pais e filhos, ajudo a família a se escutar com mais clareza e afeto.", tone: "yellow", span: "md:col-span-5" },
  { key: "adultos", tag: "Adultos", title: "Entender o que sente para viver diferente", text: "Ansiedade, relações, autocobrança e momentos de mudança, trabalhados com ferramentas práticas da TCC.", tone: "mint", span: "md:col-span-5" },
];

export const FAQ = [
  { q: "A terapia on-line funciona tão bem quanto a presencial?", a: "Sim. A psicoterapia on-line é regulamentada pelo Conselho Federal de Psicologia e mantém a mesma ética, sigilo e cuidado. Muitas pessoas, inclusive adolescentes, se sentem até mais à vontade no próprio ambiente." },
  { q: "O que é a Terapia Cognitivo-Comportamental (TCC)?", a: "É uma abordagem que investiga a relação entre pensamentos, emoções e comportamentos. É estruturada, colaborativa e focada em construir ferramentas práticas para o dia a dia." },
  { q: "Como funciona o atendimento de adolescentes?", a: "Para menores de idade, é necessária a autorização dos responsáveis. O conteúdo das sessões é sigiloso, e os pais podem participar de encontros pontuais para fortalecer a comunicação familiar." },
  { q: "Do que eu preciso para a sessão?", a: "Um celular ou computador com internet, um lugar reservado onde você se sinta à vontade e, de preferência, fones de ouvido." },
  { q: "Quais são os valores e horários?", a: "Valores e horários disponíveis são informados pelo WhatsApp. É só me enviar uma mensagem." },
  { q: "Atende pessoas de qualquer cidade?", a: "Sim. Por ser on-line, o atendimento pode ser feito de onde você estiver." },
];
